import { createState } from "@tecnobit-srl/state";
import { useSsrCollector } from "@tecnobit-srl/ssr-collector";
import { filter, find } from "lodash-es";
import { useEffect } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/index.tsx
var { ContextProvider, useStore } = createState("Styles", (set) => ({
	registeredStyles: [],
	registerStyle: (style, priority = 100) => {
		set((state) => {
			if (!find(state.registeredStyles, (s) => s.name === style)) state.registeredStyles = [...state.registeredStyles, {
				name: style,
				priority
			}];
			return { ...state };
		});
		return () => {
			set((state) => {
				state.registeredStyles = filter(state.registeredStyles, (s) => s.name !== style);
				return { ...state };
			});
		};
	}
}));
function StylesProvider({ children }) {
	return /* @__PURE__ */ jsx(ContextProvider, { children });
}
function useRegisteredStyles() {
	return useStore((state) => state.registeredStyles);
}
function Style({ style, priority = 100 }) {
	const collector = useSsrCollector();
	const registerStyle = useStore((state) => state.registerStyle);
	useEffect(() => registerStyle(style, priority), [
		style,
		priority,
		registerStyle
	]);
	if (collector) collector.styles.set(style, {
		name: style,
		priority
	});
	return null;
}
//#endregion
export { Style, StylesProvider, useRegisteredStyles };
